import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9c66dd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiange" }, null, -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "username" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_field, {
      class: "field",
      modelValue: _ctx.fieldValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fieldValue) = $event)),
      "is-link": "",
      readonly: "",
      name: "picker",
      label: "负责人",
      placeholder: "请选择负责人",
      onClick: _ctx.showPopup
    }, null, 8, ["modelValue", "onClick"]),
    _createVNode(_component_van_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.show) = $event)),
      position: "bottom",
      style: { height: '93%' },
      class: "popup"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          class: "canjiandanwei-popup",
          modelValue: _ctx.personName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.personName) = $event)),
          label: "负责人",
          placeholder: "请选择负责任人",
          clearable: ""
        }, {
          button: _withCtx(() => [
            _createElementVNode("span", {
              style: {"color":"#1989fa"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, "取消")
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_pull_refresh, {
            modelValue: _ctx.refreshing,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.refreshing) = $event)),
            onRefresh: _ctx.onRefresh
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_list, {
                loading: _ctx.loading,
                "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
                finished: _ctx.finished,
                "finished-text": "没有更多了",
                onLoad: _ctx.onLoad
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkList, (item) => {
                    return (_openBlock(), _createBlock(_component_van_cell, {
                      key: item.id,
                      onClick: ($event: any) => (_ctx.selectUserEvent(item))
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1),
                        _createElementVNode("div", null, [
                          (item.photoUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "img",
                                src: item.photoUrl
                              }, null, 8, _hoisted_4))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["loading", "finished", "onLoad"])
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}